import { IAgentSourcedCreator } from '../types'

// Name precedence shared by the row and the drawer header: the creator's own reply,
// then the OnSocial fullname, then handle/username. `||` (not `??`) so a blank reply
// falls through instead of hiding the fullname. `isRealName` is true for the first two.
export const resolveCreatorName = (creator: IAgentSourcedCreator) => {
  const { creator_data } = creator
  const realName =
    creator.creator_intent?.response_name?.trim() || creator_data?.fullname || undefined
  return {
    isRealName: !!realName,
    displayName: realName ?? creator_data?.handle ?? creator_data?.username,
  }
}
